import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import TaskForm from "./taskComponents/TaskForm";

import {
  useGetTaskDetailQuery,
  useUpdateTaskMutation,
} from "store/services/taskApi";

import { useAppMeta } from "hooks";

const TaskEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Tasks", path: "/app/crm/task/list" },
    { title: "Edit Task" },
  ];

  // RTK Query
  const { data: taskDetail, isLoading: loadingTaskDetail } =
    useGetTaskDetailQuery(id);

  const [updateTask, { isLoading: updatingTask }] = useUpdateTaskMutation();

  // methods
  const handleTaskUpdate = async (data) => {
    try {
      await updateTask(data).unwrap();
      navigate(`/app/crm/task/${id}/detail`);
      toast.success("Task successfully updated!");
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Task!");
    }
  };

  useAppMeta("Edit Task");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingTaskDetail || updatingTask}
    >
      <BreadcrumbLayout.Paper>
        <TaskForm
          taskDetail={taskDetail}
          isBusy={loadingTaskDetail || updatingTask}
          onSubmit={handleTaskUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TaskEditScreen;
